
import { MessageContext } from './types';
import { GreetingGenerator } from './greeting-generator';

export class ContextDeterminer {
  private static readonly C2C_PLATFORMS = [
    'ebay', 'facebook_marketplace', 'offerup', 'craigslist', 'mercari', 
    'poshmark', 'depop', 'nextdoor', 'varagesale', 'vinted', 'reverb', 
    'kidizen', 'tradesy', 'chairish', 'fivemiles', 'gunbroker'
  ];

  static getDefaultContext(merchantName: string, platformInfo: any, issue: string): MessageContext {
    // For C2C platforms, ALWAYS address the seller directly
    if (this.isC2CPlatform(platformInfo.platform)) {
      return {
        targetRecipient: 'seller',
        communicationStyle: 'direct',
        relationship: 'peer_to_peer',
        greeting: GreetingGenerator.getSellerGreeting(merchantName, platformInfo),
        reasoning: `${GreetingGenerator.getPlatformName(platformInfo.platform)} is a C2C platform - addressing the individual seller directly`
      };
    }

    // For private sellers on mixed platforms (like Amazon marketplace), address the seller
    if (platformInfo.isPrivateSeller && platformInfo.transactionType === 'C2C') {
      return {
        targetRecipient: 'seller',
        communicationStyle: 'direct',
        relationship: 'peer_to_peer',
        greeting: GreetingGenerator.getSellerGreeting(merchantName, platformInfo),
        reasoning: 'Private seller on marketplace platform - addressing seller directly'
      };
    }

    // For business sellers or B2C transactions, address the merchant
    if (platformInfo.transactionType === 'B2C' || !platformInfo.isPrivateSeller) {
      return {
        targetRecipient: 'merchant',
        communicationStyle: 'formal',
        relationship: 'business_to_consumer',
        greeting: `Dear ${merchantName} Support`,
        reasoning: 'Business transaction - addressing merchant support'
      };
    }

    // Fallback to merchant addressing
    return {
      targetRecipient: 'merchant',
      communicationStyle: 'formal',
      relationship: 'business_to_consumer',
      greeting: `Dear ${merchantName} Support`,
      reasoning: 'Default to merchant addressing'
    };
  }

  static isC2CPlatform(platform: string): boolean {
    return this.C2C_PLATFORMS.includes(platform);
  }
}
